<template>
  <div>
    <top-agent-self-agent-monthly-bills v-if="this.$store.getters.userRole === 'top_agent'" />
    <merchant-self-agent-monthly-bills v-else-if="this.$store.getters.userRole === 'merchant'" />
  </div>
</template>

<script>

export default {
  name: 'AgentMonthlyBills',
  components: {
    TopAgentSelfAgentMonthlyBills: () => import('@/views/agent_monthly_bills_commission/top_agent_self/index'),
    MerchantSelfAgentMonthlyBills: () => import('@/views/agent_monthly_bills_commission/merchant_self/index')
  }
}
</script>
